import React, { useMemo, Fragment } from 'react';
import styled from 'styled-components';

import device from 'utils/device';

import { BreadCrumbOption } from '../interfaces';
import Button from './Button';

export type ComponentProps = {
  items: BreadCrumbOption[];
};

const BreadCrumbContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  margin-left: 4px;

  @media ${device.isMobile} {
    display: none;
  }
`;

const Divider = styled.div`
  position: relative;
  padding-top: 2px;
  padding-left: 5.25px;
  padding-right: 5.25px;
`;

const ButtonContainer: React.FC<ComponentProps> = ({ items }) => {
  return useMemo(
    () => (
      <BreadCrumbContainer>
        {items.map((loopedOption, index) => {
          const isLastItem = index === items.length - 1;
          const { text, link, enableLink } = loopedOption;
          return (
            <Fragment key={loopedOption.text}>
              <Button text={text} link={link} isLastItem={isLastItem} enableLink={enableLink} />
              {!isLastItem && <Divider>/</Divider>}
            </Fragment>
          );
        })}
      </BreadCrumbContainer>
    ),
    [items]
  );
};

export default ButtonContainer;
